import type { ComponentType } from "react";

import LockOpenIcon from "@material-ui/icons/LockOpen";
import PersonIcon from "@material-ui/icons/Person";
import LocalMallIcon from "@material-ui/icons/LocalMall";
import TimelineIcon from "@material-ui/icons/Timeline";
import EqualizerIcon from "@material-ui/icons/Equalizer";
import EventNoteIcon from "@material-ui/icons/EventNote";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import NotificationImportantIcon from "@material-ui/icons/NotificationImportant";
const base = "/support";

export interface NavigatorEntry {
  id: string;
  title: string;
  Icon: ComponentType;
  href: string;
  forPremium?: boolean;
  adminOnly?: boolean;
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
  order: number;
}

export const navigation: Array<NavigatorEntry> = [
  {
    id: "sales-dates",
    title: "Sales Dates",
    Icon: EventNoteIcon,
    href: `${base}/sales-dates`,
    order: 4.5,
    adminOnly: true,
  },
  {
    id: "client-versions",
    title: "Client Version",
    Icon: TimelineIcon,
    href: `${base}/client-versions`,
    order: 4,
    adminOnly: true,
  },
  {
    id: "load-timings",
    title: "Load Timings",
    Icon: EqualizerIcon,
    href: `${base}/load-timings`,
    order: 4.1,
    adminOnly: true,
  },
  {
    id: "errors",
    title: "Errors",
    Icon: ErrorOutlineIcon,
    href: `${base}/errors`,
    order: 5,
  },
  {
    id: "error-alerts",
    title: "Error Alerts",
    Icon: NotificationImportantIcon,
    href: `${base}/error-alerts/day`,
    order: 5.1,
  },
  {
    id: "ebay-limits",
    title: "eBay Limits",
    Icon: LocalMallIcon,
    href: `${base}/ebay-limits`,
    order: 3,
  },
  {
    id: "etsy-limits",
    title: "Etsy Limits",
    Icon: LocalMallIcon,
    href: `${base}/etsy-limits`,
    order: 3.5,
  },
  {
    id: "user",
    title: "User",
    Icon: PersonIcon,
    href: `${base}/user/`,
    order: 2,
  },
  {
    id: "token",
    title: "Tokens",
    Icon: LockOpenIcon,
    href: `${base}`,
    order: 1,
  },
];
